import React from "react";
import Moment from "moment";

class YCComponent extends React.Component {

    mainContainerClass = 'col-xl-10 offset-xl-1';
    locale = 'cs-CZ';
    mainTitle = 'Yourchance - Finanční gramotnost';

    numberWithSign(number) {
        return (<span className={number < 0 ? 'text-danger' : ''}>{ number > 0 ? '+' : '' }{ number }</span>)
    }

    setTitle(title) {
        document.title = (title ? title + ' | ' : '') + this.mainTitle;
    }

    formatTime(time) {
        return Moment(time).format('DD.MM.YYYY HH:mm');
    }

    formatDate(date) {
        return Moment(date).format('DD.MM.YYYY');
    }

}

export default YCComponent;